export default __webpack_public_path__ + "static/logo-6a488c81b8b00d349b5ea0d294ad4889.png";